import React from 'react'
import './style/index.css'
import { useState } from 'react'
import classNames from 'classnames'
export default function Historys() {
  //历史记录数据
  const [history] = useState({
    historys: [
      {
        historyName: 'Clash for Win',
        historyPng: require('../../assets/ClashforWin.png'),
      },
      {
        historyName: 'th(375x195)',
        historyPng: require('../../assets/th(375x195).png'),
      },
      {
        historyName: 'React App',
        historyPng: require('../../assets/ReactApp.png'),
      },
      {
        historyName: '邮递员API平台',
        historyPng: require('../../assets/邮递员API平台.png'),
      },
      {
        historyName: 'React App',
        historyPng: require('../../assets/ReactApp.png'),
      },
      {
        historyName: '邮递员API平台',
        historyPng: require('../../assets/邮递员API平台.png'),
      },
      {
        historyName: 'th(375x195)',
        historyPng: require('../../assets/th(375x195).png'),
      },
      {
        historyName: 'th(375x195)',
        historyPng: require('../../assets/th(375x195).png'),
      },
      {
        historyName: 'th(375x195)',
        historyPng: require('../../assets/th(375x195).png'),
      },
    ],
  })
  //广告数据
  const [advert] = useState({
    adverts: [
      {
        advertName: '必应搜索',
        advertImg: require('../../assets/必应搜索.png'),
      },
      {
        advertName: '哔哩哔哩',
        advertImg: require('../../assets/哔哩哔哩.png'),
      },
      {
        advertName: '爱奇艺',
        advertImg: require('../../assets/aqy.png'),
      },
      {
        advertName: '京东',
        advertImg: require('../../assets/JD.png'),
      },
      {
        advertName: '4366小游戏',
        advertImg: require('../../assets/4366.png'),
      },
      {
        advertName: '优酷',
        advertImg: require('../../assets/yk.png'),
      },
      {
        advertName: '唯品会',
        advertImg: require('../../assets/wph.png'),
      },
      {
        advertName: '必应搜索',
        advertImg: require('../../assets/必应搜索.png'),
      },
      {
        advertName: '必应搜索',
        advertImg: require('../../assets/必应搜索.png'),
      },
      {
        advertName: '爱奇艺',
        advertImg: require('../../assets/aqy.png'),
      },
      {
        advertName: '京东',
        advertImg: require('../../assets/JD.png'),
      },
      {
        advertName: '4366小游戏',
        advertImg: require('../../assets/4366.png'),
      },
      {
        advertName: '优酷',
        advertImg: require('../../assets/yk.png'),
      },
      {
        advertName: '唯品会',
        advertImg: require('../../assets/wph.png'),
      },
      {
        advertName: '爱奇艺',
        advertImg: require('../../assets/aqy.png'),
      },
      {
        advertName: '京东',
        advertImg: require('../../assets/JD.png'),
      },
    ],
  })
  //控制历史记录点击事件
  const [browsing, setBrowsing] = useState(true)
  const dianji = () => {
    const left = document.getElementsByClassName('h-left')
    const right = document.getElementsByClassName('h-right')
    if (browsing) {
      left[0].style.visibility = 'hidden'
      right[0].style.visibility = 'hidden'
      setBrowsing(false)
    } else {
      left[0].style.visibility = 'visible'
      right[0].style.visibility = 'visible'
      setBrowsing(true)
    }
  }
  return (
    <>
      <div className="historys">
        <div className="h-center">
          <div className="zd">
            <i
              className={classNames(' iconfont', {
                'icon-xiangshangjiantou': browsing === true,
                'icon-xiajiantou': browsing === false,
              })}
              onClick={dianji}></i>
          </div>
          <div className="h-left">
            {history.historys.map((item, index) => (
              <div className="h-item" key={index}>
                <div className="image">
                  <img src={item.historyPng} alt="" />
                </div>
                <span>{item.historyName}</span>
              </div>
            ))}
          </div>
          <div className="h-right">
            <i className=" iconfont icon-jiahao1 "></i>
          </div>
        </div>
      </div>
      <div className="advertisement">
        <div className="advert-center">
          <div className="advert-left">
            {advert.adverts.map((item, index) => (
              <div className="left-item" key={index}>
                <img src={item.advertImg} alt="" />
                <span>{item.advertName}</span>
              </div>
            ))}
          </div>
          <div className="advert-right">
            <div className="right-top">
              <i className=" iconfont icon-dian "></i>
            </div>
            <div className="right-bottom">
              <span>广告</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
